import {ParcelIncident} from '@domain/model/Account/ParcelIncident';
import {ViewParcelIncidentByUserIdQuery} from '@domain/model/Account/ParcelIncident/ViewParcelIncidentByUserIdQuery';
import {getAuthHeader} from '@infra/api/authManager/authManager';
import {fetch} from '@infra/api/fetch';

import {DEFAULT_HEADERS} from '../../_utils/defaultHeaders';

const VIEW_PARCEL_INCIDENT_URL = '/logistics/view-parcel-incident-by-user-id';

const parseResponse = async (result: Response): Promise<unknown> => {
  const rawResponse = await result.text();

  if (!rawResponse) {
    return null;
  }

  try {
    return JSON.parse(rawResponse);
  } catch {
    return null;
  }
};

const normalizeResponse = (response: unknown): ParcelIncident | null => {
  if (!response || typeof response !== 'object') {
    return null;
  }

  const {reason} = response as {reason?: unknown};
  if (typeof reason !== 'string' || reason.length === 0) {
    return null;
  }

  return {...(response as Record<string, unknown>), reason} as ParcelIncident;
};

const viewParcelIncidentByUserId = async ({
  userId,
}: ViewParcelIncidentByUserIdQuery): Promise<ParcelIncident | null> => {
  const authHeader = await getAuthHeader();

  try {
    const result = await fetch(VIEW_PARCEL_INCIDENT_URL, {
      method: 'POST',
      headers: {
        ...authHeader,
        ...DEFAULT_HEADERS,
      },
      body: JSON.stringify({userId}),
    });

    const response = await parseResponse(result);

    if (!result.ok) {
      return Promise.reject(response);
    }

    return normalizeResponse(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const ApiParcelIncidentRepository = {
  viewParcelIncidentByUserId,
};
